export interface EmployeeRequest {
  firstName: string;
  lastName: string;
  email: string;
  roles: Roles[];

}

export interface EmployeeDto extends EmployeeRequest {
  id: string;
  keycloakId: string;
}

export enum Roles {
  ADMIN = 'ADMIN',
  USER = 'USER',
  MAINTAINER = 'MAINTAINER'
}

export function getEmptyEmployeeRequest(): EmployeeRequest {
  return {
    firstName: '',
    lastName: '',
    email: '',
    roles: [Roles.USER]
  };
}

export function getEmptyEmployeeDto(): EmployeeDto {
  return {
    id:'',
    keycloakId:'',
    firstName: '',
    lastName: '',
    email: '',
    roles: [Roles.USER]
  };
}
